import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Footer_ScreenContext } from "../footer/footer-context";

declare let window: any;

export interface IProductBasketWeb_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IProductBasketWeb_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  PostOrderWithValidation: number;
  PostOrderWithValidation_dummy: number;
  Notify: boolean;
  Notify_dummy: boolean;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  GoBack: any;
  GoBack_dummy: any;
  B2BGetUserId: any[];
  B2BGetUserId_dummy: any[];
  B2BListBasket: any[];
  B2BListBasket_dummy: any[];
  B2BBasketCount: any[];
  B2BBasketCount_dummy: any[];
  SetFocusTo: any;
  SetFocusTo_dummy: any;
  B2BDeletedBasketAll: number;
  B2BDeletedBasketAll_dummy: number;
  B2BDeleteBasketItem: number;
  B2BDeleteBasketItem_dummy: number;
  B2BNmberInputDegeriAtaBasketMinusOpNew: any[];
  B2BNmberInputDegeriAtaBasketMinusOpNew_dummy: any[];
  B2BNmberInputDegeriAtaBasketPlusOpNew: any[];
  B2BNmberInputDegeriAtaBasketPlusOpNew_dummy: any[];
  B2BNmberInputDegeriAtaBasket: any[];
  B2BNmberInputDegeriAtaBasket_dummy: any[];
}

export class ProductBasketWeb_ScreenBase extends React.PureComponent<
  IProductBasketWeb_ScreenProps,
  any
> {
  static contextType = Footer_ScreenContext;
  declare context: React.ContextType<typeof Footer_ScreenContext>;
  productbasketweb_236825_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 821776,
          PropertyName: "label",
          Value: "Sepeti Onayla",
          TagName: "Button1_label",
        },
        {
          Id: 123455,
          PropertyName: "value",
          Value: "Sepetinizde",
          TagName: "Label14_value",
        },
        {
          Id: 128520,
          PropertyName: "value",
          Value: "Adet Ürün Var",
          TagName: "Label16_value",
        },
        {
          Id: 471205,
          PropertyName: "value",
          Value: "Sepetim",
          TagName: "Label2_value",
        },
        {
          Id: 258162,
          PropertyName: "label",
          Value: "Açıklama Ekle",
          TagName: "Button3_label",
        },
        {
          Id: 97639,
          PropertyName: "label",
          Value: "Sepeti temizle",
          TagName: "Button2_label",
        },
        {
          Id: 236825,
          PropertyName: "nodatafoundmessage",
          Value: "Sepetinizde ürün bulunmamaktadır.",
          TagName: "Table1_nodatafoundmessage",
        },
        {
          Id: 360122,
          PropertyName: "value",
          Value: "Sepet Açıklaması",
          TagName: "Label13_value",
        },
        {
          Id: 649332,
          PropertyName: "placeholder",
          Value: "Sepet Açıklaması Giriniz...",
          TagName: "TextArea1_placeholder",
        },
        {
          Id: 705765,
          PropertyName: "value",
          Value: "Koleksiyon",
          TagName: "Label12_value",
        },
        {
          Id: 873401,
          PropertyName: "value",
          Value: "Desen",
          TagName: "Label11_value",
        },
        {
          Id: 687735,
          PropertyName: "value",
          Value: "Ebat",
          TagName: "Label9_value",
        },
        {
          Id: 18758713,
          PropertyName: "064b40f1-02ab-881d-03ab-70299d9e0e2e_confirmation",
          Value: "Tüm sepeti silmek istiyor musunuz?",
          TagName: "B2BDeletedBasketAll_confirmation",
          IsConfirmation: true,
        },
        {
          Id: 66091178,
          PropertyName: "90f750ef-396c-a40e-d569-fe67ce7695a3_confirmation",
          Value: "Ürünü silmek istediğinize emin misiniz?",
          TagName: "B2BDeleteBasketItem_confirmation",
          IsConfirmation: true,
        },
        {
          Id: 4176901,
          PropertyName: "ebfd57d1-be3c-e7d0-c5f8-2718eb1b6ec9_notify",
          Value: "Siparişiniz başarılı bir şekilde alınmıştır, teşekkürler!",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 6112387,
          PropertyName: "e32539bf-104b-8f5a-faa0-f16d57415d25_notify",
          Value: "Sipariş onaylama başarısız!",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 51368541,
          PropertyName: "8ec26885-e879-8aa1-3a47-6a33ae8f5bf0_notify",
          Value: "Tüm sepet temizlendi!",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 39715286,
          PropertyName: "dcdd1d24-890d-375c-33cf-6bdf697505a5_notify",
          Value: "Ürün sepetten başarıyla kaldırıldı!",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 821776,
          PropertyName: "label",
          Value: "Confirm Basket",
          TagName: "Button1_label",
        },
        {
          Id: 123455,
          PropertyName: "value",
          Value: "In your basket",
          TagName: "Label14_value",
        },
        {
          Id: 128520,
          PropertyName: "value",
          Value: "Number of Products Available",
          TagName: "Label16_value",
        },
        {
          Id: 471205,
          PropertyName: "value",
          Value: "My Basket",
          TagName: "Label2_value",
        },
        {
          Id: 258162,
          PropertyName: "label",
          Value: "Add Description",
          TagName: "Button3_label",
        },
        {
          Id: 97639,
          PropertyName: "label",
          Value: "Clear Basket",
          TagName: "Button2_label",
        },
        {
          Id: 236825,
          PropertyName: "nodatafoundmessage",
          Value: "Your basket is empty.",
          TagName: "Table1_nodatafoundmessage",
        },
        {
          Id: 360122,
          PropertyName: "value",
          Value: "Basket Description",
          TagName: "Label13_value",
        },
        {
          Id: 649332,
          PropertyName: "placeholder",
          Value: "Please enter a description for your basket...",
          TagName: "TextArea1_placeholder",
        },
        {
          Id: 705765,
          PropertyName: "value",
          Value: "Collection",
          TagName: "Label12_value",
        },
        {
          Id: 873401,
          PropertyName: "value",
          Value: "Pattern",
          TagName: "Label11_value",
        },
        {
          Id: 687735,
          PropertyName: "value",
          Value: "Size",
          TagName: "Label9_value",
        },
        {
          Id: 50545640,
          PropertyName: "064b40f1-02ab-881d-03ab-70299d9e0e2e_confirmation",
          Value: "Do you want to delete the entire basket?",
          TagName: "B2BDeletedBasketAll_confirmation",
          IsConfirmation: true,
        },
        {
          Id: 87261499,
          PropertyName: "90f750ef-396c-a40e-d569-fe67ce7695a3_confirmation",
          Value: "Are you sure you want to delete the product?",
          TagName: "B2BDeleteBasketItem_confirmation",
          IsConfirmation: true,
        },
        {
          Id: 63617441,
          PropertyName: "ebfd57d1-be3c-e7d0-c5f8-2718eb1b6ec9_notify",
          Value: "Your order has been successfully received, thank you!",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 68141974,
          PropertyName: "e32539bf-104b-8f5a-faa0-f16d57415d25_notify",
          Value: "Order confirmation failed!",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 85055434,
          PropertyName: "8ec26885-e879-8aa1-3a47-6a33ae8f5bf0_notify",
          Value: "The entire basket has been emptied!",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 36784502,
          PropertyName: "dcdd1d24-890d-375c-33cf-6bdf697505a5_notify",
          Value: "The product has been successfully removed from the cart!",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "6e0a29c3-8cdb-4a90-891e-c81f0d57056f",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 123455, PropertyName: "value", Value: "Sepetinizde" },
        { Id: 128520, PropertyName: "value", Value: "Adet Ürün Var" },
        { Id: 821776, PropertyName: "label", Value: "Sepeti Onayla" },
        { Id: 471205, PropertyName: "value", Value: "Sepetim" },
        { Id: 258162, PropertyName: "label", Value: "Açıklama Ekle" },
        { Id: 97639, PropertyName: "label", Value: "Sepeti temizle" },
        {
          Id: 236825,
          PropertyName: "nodatafoundmessage",
          Value: "Sepetinizde ürün bulunmamaktadır.",
        },
        { Id: 619943, PropertyName: "title", Value: "Title" },
        { Id: 705765, PropertyName: "value", Value: "Koleksiyon" },
        {
          Id: 876588,
          PropertyName: "value",
          Value: "[datafield:productattribute02description]",
        },
        { Id: 873401, PropertyName: "value", Value: "Desen" },
        {
          Id: 154079,
          PropertyName: "value",
          Value: "[datafield:productattribute03description]",
        },
        { Id: 687735, PropertyName: "value", Value: "Ebat" },
        {
          Id: 289538,
          PropertyName: "value",
          Value: "[datafield:sizedescription]",
        },
        { Id: 244781, PropertyName: "title", Value: "Title" },
        { Id: 306453, PropertyName: "value", Value: "[datafield:qty1]" },
        { Id: 382542, PropertyName: "placeholder", Value: "15" },
        { Id: 360122, PropertyName: "value", Value: "Sepet Açıklaması" },
        {
          Id: 649332,
          PropertyName: "placeholder",
          Value: "Sepet Açıklaması Giriniz...",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.productbasketweb_236825_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      PostOrderWithValidation: 0,
      Notify: false,
      TriggerEvent: "",
      NAVIGATE: "",
      GoBack: "",
      B2BGetUserId: [],
      B2BListBasket: [],
      B2BBasketCount: [],
      SetFocusTo: "",
      B2BDeletedBasketAll: 0,
      B2BDeleteBasketItem: 0,
      B2BNmberInputDegeriAtaBasketMinusOpNew: [],
      B2BNmberInputDegeriAtaBasketPlusOpNew: [],
      B2BNmberInputDegeriAtaBasket: [],
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "productbasketweb",
        "footer_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.ProductBasketWebPageInit();
    } else if (
      !this.context?.callCallbackFunction ||
      this.context?.isMasterPageInitLoaded
    ) {
      this._prevMasterPageInitLoaded =
        this.context?.isMasterPageInitLoaded ?? false;
      await this.ProductBasketWebPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "productbasketweb",
      "footer_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["B2BCustomer"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "productbasketweb",
      "footer_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ProductBasketWebPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.ProductBasketWebPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  ProductBasketWebPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      KUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      TbUserId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      Kuserid_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductBasketWeb/ProductBasketWebPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BGetUserId = result?.data.b2BGetUserId;
    stateVars.B2BListBasket = result?.data.b2BListBasket;

    stateVars.B2BBasketCount = result?.data.b2BBasketCount;
    formVars.productbasketweb_609262_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BBasketCount !== undefined
        ? stateVars.B2BBasketCount?.length > 0
          ? stateVars.B2BBasketCount[0].basketCount
          : null
        : this.state.B2BBasketCount?.length > 0
        ? this.state.B2BBasketCount[0].basketCount
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductBasketWebPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductBasketWebPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.productbasketweb_609262_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BBasketCount !== undefined
        ? stateVars.B2BBasketCount?.length > 0
          ? stateVars.B2BBasketCount[0].basketCount
          : null
        : this.state.B2BBasketCount?.length > 0
        ? this.state.B2BBasketCount[0].basketCount
        : null
    );

    stateVars.dataSource_236825 =
      stateVars.B2BListBasket ?? this.state.B2BListBasket;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  ProductBasketWebComponent_821776_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].v3CustomerCode
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].v3CustomerCode
            : null
        ),
        "string"
      ),
      Description_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "productbasketweb_649332_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      sepetId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BListBasket !== undefined
            ? stateVars.B2BListBasket?.length > 0
              ? stateVars.B2BListBasket[0].basketId
              : null
            : this.state.B2BListBasket?.length > 0
            ? this.state.B2BListBasket[0].basketId
            : null
        ),
        "Guid"
      ),
      CustomerUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BListBasket !== undefined
            ? stateVars.B2BListBasket?.length > 0
              ? stateVars.B2BListBasket[0].customerUserID
              : null
            : this.state.B2BListBasket?.length > 0
            ? this.state.B2BListBasket[0].customerUserID
            : null
        ),
        "Guid"
      ),
      lines_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.B2BListBasket),
        "any[]"
      ),
      lines_ItemCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.B2BListBasket?.itemCode),
        "string"
      ),
      lines_Quantity_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.B2BListBasket?.qty1),
        "number"
      ),
      lines_Price_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.B2BListBasket?.itemPrice),
        "number"
      ),
      SubCurrAccID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].v3SubCustomerAddressID
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].v3SubCustomerAddressID
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductBasketWeb/ProductBasketWebComponent_821776_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.PostOrderWithValidation = result?.data.postOrderWithValidation;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ProductBasketWebComponent_821776_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductBasketWebComponent_821776_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.PostOrderWithValidation),
        "1"
      )
    ) {
      stateVars.Notify = await ReactSystemFunctions.notify(
        this,
        ReactSystemFunctions.translateCustomActions(
          this.ml,
          "ebfd57d1_be3c_e7d0_c5f8_2718eb1b6ec9_notify",
          this.defaultML,
          "Siparişiniz başarılı bir şekilde alınmıştır, teşekkürler!"
        ),
        ReactSystemFunctions.convertToTypeByName("success", "string"),
        ReactSystemFunctions.convertToTypeByName("top", "string"),
        3,
        ReactSystemFunctions.convertToTypeByName("", "string"),
        ReactSystemFunctions.convertToTypeByName("", "string"),
        0
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductBasketWebComponent_821776_onClick2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductBasketWebComponent_821776_onClick2_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  ProductBasketWebComponent_821776_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.PostOrderWithValidation),
        "0"
      )
    ) {
      stateVars.Notify = await ReactSystemFunctions.notify(
        this,
        ReactSystemFunctions.translateCustomActions(
          this.ml,
          "e32539bf_104b_8f5a_faa0_f16d57415d25_notify",
          this.defaultML,
          "Sipariş onaylama başarısız!"
        ),
        ReactSystemFunctions.convertToTypeByName("danger", "string"),
        ReactSystemFunctions.convertToTypeByName("top", "string"),
        2,
        ReactSystemFunctions.convertToTypeByName("", "string"),
        ReactSystemFunctions.convertToTypeByName("", "string"),
        0
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductBasketWebComponent_821776_onClick3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductBasketWebComponent_821776_onClick3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  ProductBasketWebComponent_821776_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.ProductBasketWebPageInit();

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/productlistcollectionwebscreen") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "ProductBasketWeb",
      "ProductListCollectionWebScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductBasketWebComponent_726476_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductBasketWebComponent_258162_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetFocusTo = await ReactSystemFunctions.setFocusTo(
      ReactSystemFunctions.convertToTypeByName("649332", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductBasketWebComponent_97639_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KUserid_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "064b40f1_02ab_881d_03ab_70299d9e0e2e_confirmation",
        this.defaultML,
        "Tüm sepeti silmek istiyor musunuz?"
      ),
      "poppins",
      "Confirmation",
      "confirmation",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "ProductBasketWeb/ProductBasketWebComponent_97639_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.B2BDeletedBasketAll = result?.data.b2BDeletedBasketAll;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductBasketWebComponent_97639_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductBasketWebComponent_97639_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.ProductBasketWebPageInit();

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "8ec26885_e879_8aa1_3a47_6a33ae8f5bf0_notify",
        this.defaultML,
        "Tüm sepet temizlendi!"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductBasketWebComponent_591397_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productbasketweb_236825_value",
          "basketId"
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "90f750ef_396c_a40e_d569_fe67ce7695a3_confirmation",
        this.defaultML,
        "Ürünü silmek istediğinize emin misiniz?"
      ),
      "poppins",
      "Confirmation",
      "confirmation",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "ProductBasketWeb/ProductBasketWebComponent_591397_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.B2BDeleteBasketItem = result?.data.b2BDeleteBasketItem;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductBasketWebComponent_591397_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductBasketWebComponent_591397_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.ProductBasketWebPageInit();

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "dcdd1d24_890d_375c_33cf_6bdf697505a5_notify",
        this.defaultML,
        "Ürün sepetten başarıyla kaldırıldı!"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductBasketWebComponent_639051_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BasketId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productbasketweb_236825_value",
          "basketId"
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductBasketWeb/ProductBasketWebComponent_639051_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BNmberInputDegeriAtaBasketMinusOpNew =
      result?.data.b2BNmberInputDegeriAtaBasketMinusOpNew;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ProductBasketWebComponent_639051_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductBasketWebComponent_639051_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.ProductBasketWebPageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductBasketWebComponent_219039_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BasketId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productbasketweb_236825_value",
          "basketId"
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductBasketWeb/ProductBasketWebComponent_219039_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BNmberInputDegeriAtaBasketPlusOpNew =
      result?.data.b2BNmberInputDegeriAtaBasketPlusOpNew;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ProductBasketWebComponent_219039_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductBasketWebComponent_219039_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.ProductBasketWebPageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductBasketWebComponent_382542_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Qty1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "Table_236825_qty1",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      BasketId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productbasketweb_236825_value",
          "basketId"
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductBasketWeb/ProductBasketWebComponent_382542_onBlur",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BNmberInputDegeriAtaBasket =
      result?.data.b2BNmberInputDegeriAtaBasket;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ProductBasketWebComponent_382542_onBlur1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductBasketWebComponent_382542_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.ProductBasketWebPageInit();

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.B2BNmberInputDegeriAtaBasket !== undefined
          ? stateVars.B2BNmberInputDegeriAtaBasket?.length > 0
            ? stateVars.B2BNmberInputDegeriAtaBasket[0].message
            : null
          : this.state.B2BNmberInputDegeriAtaBasket?.length > 0
          ? this.state.B2BNmberInputDegeriAtaBasket[0].message
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ProductBasketWebPageInit();
    }
  }
}
